import * as React from 'react';

import { EMessageType } from '../../types/messageType';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessageLayout } from '../ChatMessageLayout';
import { ChatMessage } from '../ChatMessage';
import { TypingMessage } from '../TypingMessage';

/* istanbul ignore next */
export const ChatMessageChatbotTyping = () => {
  return (
    <ChatMessageLayout messageType={EMessageType.Incoming}>
      <ChatMessage>
        <ChatMessageBubble messageType={EMessageType.Incoming} withTail>
          <TypingMessage />
        </ChatMessageBubble>
      </ChatMessage>
    </ChatMessageLayout>
  );
};
